mutation generateTopic($isMasterView: Boolean) {
  topic: generateTopic(isMasterView: $isMasterView) {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
